<template>
  <div class="starters-placeholder">
    <b-alert variant="info" show>
      <strong>Starters v2 — Conversation Starters (Embedded)</strong> render into a page element
      you target with a CSS selector, set in
      <em>Engagement → Widget editor → (widget) → Position</em>.
      Copy the selector below, paste it in the widget's <em>"Paste your selector"</em> field,
      then Load the tag.
      <br />
      <small class="text-muted">
        Reminder: starters only display on catalog <strong>product pages</strong> (Project URL must
        match a product in the catalog).
      </small>
    </b-alert>

    <b-alert variant="warning" show>
      ⚠ The playground page can't be scraped yet, so injected starters may be limited to your
      <strong>static (manual)</strong> starters — <strong>AI-generated</strong> starters won't be
      produced here.
    </b-alert>

    <b-form-group label="Anchor CSS selector (.class or #id)" description="This is what you paste in the widget's Position tab.">
      <b-input-group>
        <b-form-input v-model.trim="selector" placeholder="#conversation-starters" />
        <b-input-group-append>
          <b-button variant="outline-secondary" @click="copySelector">
            <b-icon-clipboard></b-icon-clipboard>&nbsp;{{ copied ? 'Copied!' : 'Copy' }}
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </b-form-group>

    <p class="text-muted mb-2">
      The starters widget mounts before / inside / after this placeholder (per the widget's
      <em>Position relative</em> setting):
    </p>

    <div class="anchor-wrapper">
      <span class="anchor-label">↳ starters anchor ({{ selector || 'no selector' }})</span>
      <div v-if="anchorId" :id="anchorId" class="idz-starters-anchor"></div>
      <div v-else-if="anchorClass" :class="anchorClass" class="idz-starters-anchor"></div>
      <div v-else class="idz-starters-anchor idz-starters-anchor--invalid"></div>
    </div>

    <b-alert v-if="!anchorId && !anchorClass" variant="warning" show class="mt-2 py-2">
      Selector must start with <code>#</code> (id) or <code>.</code> (class).
    </b-alert>
  </div>
</template>

<script>
export default {
  name: 'StartersPlaceholder',
  data() {
    return {
      selector: '#conversation-starters',
      copied: false,
    };
  },
  computed: {
    anchorId() {
      return this.selector.startsWith('#') ? this.selector.slice(1) : '';
    },
    anchorClass() {
      return this.selector.startsWith('.') ? this.selector.slice(1) : '';
    },
  },
  methods: {
    copySelector() {
      navigator.clipboard.writeText(this.selector).then(() => {
        this.copied = true;
        setTimeout(() => {
          this.copied = false;
        }, 1500);
      });
    },
  },
};
</script>

<style scoped>
.anchor-wrapper {
  position: relative;
  margin: 8px 0 16px;
  padding-top: 18px;
}

.idz-starters-anchor {
  min-height: 64px;
  border: 1px dashed #cfd8dc;
  border-radius: 6px;
  background: #fff;
  padding: 8px;
}

.idz-starters-anchor--invalid {
  border-color: #e0a800;
}

.anchor-label {
  position: absolute;
  top: 0;
  left: 4px;
  font-size: 12px;
  color: #90a4ae;
}
</style>
